import React, { useMemo } from 'react';
import { Brand } from 'common/features/store/duck/search-generic/utils/searchResultBrandsToBrands';

import { createStyles } from 'utils/createStyle';
import { convertBrandToCardProps } from 'components/bonus/CardProps';
import { BrandCardSlim } from 'components/brand-card/BrandCardSlim';
import { useSearchGridStyles } from 'features/search/components/hooks';
import { useRootSelector } from 'common/features/featuresReducer';

interface FavoritesGridProps {
    isLoading: boolean;
    items: Brand[];
    suggestions: Brand[];
}

export const FavoritesGrid = ({ isLoading, items, suggestions }: FavoritesGridProps) => {
    const emptyBrand: Brand = {
        id: '0',
        name: '',
        rebate: 0,
        isOnBonus: false,
        isFeatured: false,
        imageUrl: '',
        keyWords: [],
        isLocalProduct: false,
        productIds: [],
        categories: [],
        canDoubleDip: false,
        containsAffiliateOffer: false,
        isAffiliateOfferOnBonus: false,
        isRaiseRightBrand: false,
        isRaiseRightGiftCardOnBonusOrAffiliateOnBonus: false,
        newBannerExpiration: null,
    };
    const hasFavorites = useRootSelector((s) => s.store.brands.favorites.length > 0);

    const { styles, resultsContainer } = useStyles();

    const favoriteBrands = isLoading
        ? new Array(12).fill(0).map((_, index) => ({
              ...emptyBrand,
              id: index.toString(),
          }))
        : items;

    return (
        <div className={resultsContainer}>
            <>
                {hasFavorites &&
                    favoriteBrands?.map((brd) => {
                        const cardProps = convertBrandToCardProps(brd);
                        cardProps.isLoading = isLoading;
                        return <BrandCardSlim key={brd.id} styles={styles} data={cardProps} />;
                    })}
                {!isLoading && hasFavorites && favoriteBrands.length === 0 && (
                    <span>No gift cards were found.</span>
                )}
                {!isLoading && !hasFavorites ? <PopularBrands suggestions={suggestions} /> : null}
            </>
        </div>
    );
};

const useStyles = () => {
    const [, width] = useSearchGridStyles<'150', '180'>('150', '180');

    return {
        styles: createStyles({
            cardContainer: [
                '',
                {
                    width: `${width}px`,
                    height: 210,
                },
            ],
            favoritesOverrides: [
                '',
                {
                    width: `${width}px`,
                },
            ],
        }),
        resultsContainer: 'flex flex-wrap gap-4 justify-center',
    };
};

const PopularBrands = ({ suggestions }: Pick<FavoritesGridProps, 'suggestions'>) => {
    const brandCards = useMemo(() => {
        return suggestions.map((suggestion: Brand) => convertBrandToCardProps(suggestion));
    }, [suggestions]);

    const { styles, resultsContainer } = useStyles();

    return (
        <div>
            <div className="text-center mb-4">
                <p className="text-5xl text-brand-dark">No Favorites Yet?</p>
                <p className="text-2xl text-grey-2">
                    These brands are the most popular way to earn for your organization.
                </p>
            </div>
            <div className={resultsContainer}>
                {brandCards.map((bc) => (
                    <BrandCardSlim key={bc.id} styles={styles} data={bc} />
                ))}
            </div>
        </div>
    );
};
